import { ChannelType } from "@tactical-agent-neural-knowledge/sdk/contracts/channel";
import { useChannel } from "@tactical-agent-neural-knowledge/sdk/react";
import { createFileRoute, Outlet } from "@tanstack/react-router";
import { useEffect, useRef } from "react";
import { RadarView } from "../features/radar/RadarView";
import { useShell } from "../features/shell/ShellContext";
import { parseMessageSearch } from "../features/tread/permalink";
import { TreadView } from "../features/tread/TreadView";

function ChannelPage() {
  const channelId = Route.useParams().channel;
  const channel = useChannel(channelId);
  const { m, open } = Route.useSearch();
  const { openTreadSettings } = useShell();
  // A hosting notice links here to approve a build or change what the product runs on.
  // Once per arrival: closing the settings must not open them again.
  const opened = useRef("");
  useEffect(() => {
    if (open === "code" && opened.current !== channelId) {
      opened.current = channelId;
      openTreadSettings(channelId, "code");
    }
  }, [open, channelId, openTreadSettings]);
  // A Radar is a grid, not a conversation.
  if (channel?.type === ChannelType.MONITOR) return <RadarView channelId={channelId} />;
  return <TreadView channelId={channelId} kind="tread" messageId={m} openGoal={open === "goal"} />;
}

export const Route = createFileRoute("/w/$ws/c/$channel")({
  validateSearch: parseMessageSearch,
  component: () => (
    <>
      <ChannelPage />
      <Outlet />
    </>
  ),
});
